export default __webpack_public_path__ + "locales/fi/Settings.json?hash=a4321cbf97731d6502dd7b4d8e4b9a50";